export default function Home() {
  return <></>;
}

export async function getServerSideProps() {
  return {
    redirect: {
      destination: "https://murfy.fr/reconditionne",
      permanent: false,
    },
  };
}
